export const OCC_ENDPOINTS = {
  deliveryDate: 'current-user/carts/${cartId}/delivery/preview',
  deliveryCalculator: '/delivery/timeSlots',
  deliveryPolygons: '/stores/delivery/zones',
};
